import INavBar from '@src/component/INavBar'
import {GlobalContext} from '@src/context'
import {actionType} from '@src/context/actionType'
import React, {useContext, useState} from 'react'
import IndexPage from '../main'
import LoanCenter from './components/loan-center'
import AllCase from './components/all'

import './index.scss'

function CustomerInto() {
    const {
        state: {firstKey, secondKey},
        dispatch,
    } = useContext(GlobalContext)

    const [activeKey, setActiveKey] = useState(firstKey || '1')
    const [activeSecondKey, setActiveSecondKey] = useState(secondKey || 1)

    const changeActive = (key: string) => {
        if (key !== activeKey) {
            dispatch({type: actionType.SAVE_FIRST_KEY, payload: key})
            setActiveKey(key)
        }
    }

    const changeActiveSecond = (key: number) => {
        if (key !== activeSecondKey) {
            dispatch({type: actionType.SAVE_SECOND_KEY, payload: key})
            setActiveSecondKey(key)
        }
    }
    return (
        <>
            <INavBar title="客户进件"/>
            <div className="info-box">
                <div className="box-tab">
                    <div className={`${activeKey === '0' ? 'active' : ''}`}
                         onClick={() => changeActive('0')}
                    >全部
                    </div>
                    <div
                        className={`${activeKey === '1' ? 'active' : ''}`}
                        onClick={() => changeActive('1')}
                    >
                        申请准入
                    </div>
                    <div
                        className={`${activeKey === '2' ? 'active' : ''}`}
                        onClick={() => changeActive('2')}
                    >
                        业务办理
                    </div>
                </div>
                {activeKey === '0' && <AllCase/>}
                {activeKey === '1' && <IndexPage/>}
                {activeKey === '2' && (
                    <LoanCenter
                        changeKey={changeActiveSecond}
                        activeSecondKey={activeSecondKey}
                    />
                )}
            </div>
        </>
    )
}

export default CustomerInto
